export const sideMenuConst = {

 SIDEMU_IS_COLLAPSED_KEY : 'SIDEMENU_IS_OPENED_KEY',
 SIDEMU_IS_COLLAPSED_VALUE : true,
 SIDEMU_IS_NOT_COLLAPSED_VALUE : false,
 READ_LOCALSTORAGE : false,
 WRITE_LOCALSTORAGE : true,


 OPEN_SIDE_MENU   : 'OPEN_SIDE_MENU',
 CLOSE_SIDE_MENU  : 'CLOSE_SIDE_MENU',
 GET_SIDE_MENU_TOGGLE_STATE_FROM_LOCALSTORAGE : 'GET_SIDE_MENU_TOGGLE_STATE_FROM_LOCALSTORAGE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/sideMenuConst.js